var map = {
	"./3-he-1-da-zhuan-yun-fa.jpeg": "FqY0",
	"./3-he-1-da-zhuan-yun-fa.jpg": "KJDS",
	"./di-zhu-jin.jpeg": "qPn1",
	"./di-zhu-jin.jpg": "hDDI",
	"./huan-zai-jin-2.jpeg": "I9CK",
	"./huan-zai-jin-3.jpeg": "nXUL",
	"./huan-zai-jin.jpeg": "1VFQ",
	"./huan-zai-jin.jpg": "PugC",
	"./nan-dou-liu-xing-yan-shou-deng.jpeg": "cjI6",
	"./nan-dou-liu-xing-yan-shou-deng.jpg": "+D0l",
	"./shou-sheng-qian.jpeg": "llnJ",
	"./shou-sheng-qian.jpg": "LC92",
	"./tai-sui-dian.jpeg": "2gLp",
	"./tai-sui-dian.jpg": "Tb0Q",
	"./tai-sui-jin.jpeg": "6G0X",
	"./tai-sui-jin.jpg": "pN8N",
	"./tian-guan-jin.jpeg": "VXoR",
	"./tian-guan-jin.jpg": "0gjl",
	"./wan-fo-shen-qi-ye.jpeg": "vJe4",
	"./wan-fo-shen-qi-ye.jpg": "zj1k",
	"./wan-fo-shen-xiang-you.jpeg": "1KoL",
	"./wan-fo-shen-xiang-you.jpg": "fXWN",
	"./wen-chang-jin.jpeg": "AGts",
	"./wen-chang-jin.jpg": "qAMC",
	"./wen-wu-cai-shen-bao-ku.jpeg": "2X4D",
	"./wen-wu-cai-shen-bao-ku.jpg": "gdZU",
	"./zhu-ge-kong-ming-chen-tan-xiang.jpeg": "VE7C",
	"./zhu-ge-kong-ming-chen-tan-xiang.jpg": "XsrQ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dVTQ";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products ^\.\/.*$
// module id = dVTQ
// module chunks = 1